import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
const api = new Api()

type Props = {
  showModalConfirmDelete: boolean
  handleShowModalConfirm: any
  data: any
  handleRefreshTeams: any
}

const ConfirmDeleteContent: React.FC<Props> = ({
  showModalConfirmDelete,
  handleShowModalConfirm,
  data,
  handleRefreshTeams,
}) => {
  const navigate = useNavigate()
  const [isShow, setIsShow] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    setIsShow(showModalConfirmDelete)
  }, [showModalConfirmDelete])

  const handleClose = () => {
    setIsShow(false)
    handleShowModalConfirm(false)
  }

  const handleDelete = (id: number) => {
    setLoading(true)
    api
      .deleteMember({id_anggota: id})
      .then((response: any) => {
        setLoading(false)
        setIsShow(false)
        handleShowModalConfirm(false)
        handleRefreshTeams(true)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        toast.error(data?.meta?.message)
        handleApiError(error, navigate)
      })
  }

  return (
    <Modal show={isShow} centered size='lg'>
      <div className='p-10 text-center'>
        <p className='h6'>Konfirmasi Hapus Anggota</p>
        <p>Apakah Anda yakin ingin menghapus {data?.nama_anggota} sebagai anggota?</p>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={() => handleDelete(data?.id)}
        >
          Hapus
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleClose}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const ConfirmDeleteModal: React.FC<Props> = ({
  showModalConfirmDelete,
  handleShowModalConfirm,
  data,
  handleRefreshTeams,
}) => {
  return (
    <ConfirmDeleteContent
      showModalConfirmDelete={showModalConfirmDelete}
      handleShowModalConfirm={handleShowModalConfirm}
      data={data}
      handleRefreshTeams={handleRefreshTeams}
    />
  )
}

export default ConfirmDeleteModal
